<template>
  <div class="wg-row">
    <div class="wg-row">
      <div class="wg-row msg-row">
        <div class="time">
          {{ msg.ts | moment('DD-MM-YYYY HH:mm') }}
        </div>
      </div>
    </div>
    <div class="wg-row msg-row">
      <div v-html="$anm22.nl2br(msg.data.text)" class="com-anm22-app-text-m"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    msg: Object
  },
  computed: { 
    ...mapState({
        lang: (state) => state.lang
    })
   },
  created() {
    //console.log(this.msg);
  }
}
</script>
<style lang="scss" scoped>
.msg-row {
  flex-wrap: nowrap;
  align-items: center;
}
.time {
  font-size: 12px;
  margin-left: auto;
}